import { Injectable } from "@angular/core";
import Utils from "src/app/shared/fgi-utils";
import { FileUtilsService } from "src/app/shared/file-utils.service";
import { DatePipe } from "@angular/common";
import { BnLoadingService } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnAlertsService } from "@bndes/bndes-ux4/bn-alerts";
import { BnPipeCnpj } from "@bndes/bndes-ux4/bn-mask2/cpfcnpj";

import { ResultadoPaginado } from "src/app/model/resultado";
import { PessoaJuridica } from "src/app/model/pessoa-juridica.model";

const LIMITE_EXPORTACAO_CSV = 5000;

@Injectable({
  providedIn: 'root'
})
export class ExportPessoasJuridicasService {
  private totalResultados: number = 0;
  constructor(
    private fileUtils: FileUtilsService,
    private datePipe: DatePipe,
    private loading: BnLoadingService,
    private bnAlertsService: BnAlertsService,
    private bnCnpjPipe: BnPipeCnpj,
  ) { }

  exportar(nome, csv) {
    if (this.totalResultados > LIMITE_EXPORTACAO_CSV) {
      this.bnAlertsService.alertaAviso('Atenção', 'A exportação está limitada às primeiras 5.000 operações. Utilize os filtros disponíveis para adequar a consulta.');
    }
    this.loading.liberaTela();
    this.fileUtils.exportarArquivo(nome, "\ufeff" + csv, FileUtilsService.TEXT_CSV);
  }

  exportarPessoasJuridicas(resp: ResultadoPaginado<PessoaJuridica>) {
    let pessoasJuridicas = resp?.resultados || null;
    this.totalResultados = resp.totalRegistrosSemPaginacao;
    let csv = 'NOME; SIGLA; CNPJ\n';
    console.log("total de subscricoes para exportacao: " + pessoasJuridicas.length);
    pessoasJuridicas.forEach(pessoaJuridica => {
      csv += pessoaJuridica.nome.toUpperCase() + ';'
        + pessoaJuridica.sigla.toUpperCase() + ';'
        + this.bnCnpjPipe.transform(pessoaJuridica.cnpj) + '\n';
    });
    this.exportar('PessoasJuridicas.csv', csv);
  }

  formatarData(data, comHora?) {
    const hora = comHora ? 'HH:mm:ss' : '';
    return data ? this.datePipe.transform(data, 'dd/MM/yyyy ' + hora) : '';
  }

  formatarMoeda(moeda) {
    if (!isNaN(moeda)) {
      return Number(moeda).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
    }
    return '';
  }

  private normalizaTextoCsv(linha: string) {
    return Utils.normalizaTextoParaCsv(linha);
  }

}
